// extracted by mini-css-extract-plugin
export default {"areaReports":"index_areaReports_enJ-j clearfix","leftwrap":"index_leftwrap_V4PWO","rightWrap":"index_rightWrap_MNPVQ"};